module.exports = __webpack_public_path__ + "sgby/img/machao-pic.8ed0783.png";